import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { PLANS_QUERY_KEYS } from "../queryKeys";
import { getInvoiceDetails } from "../services/paymentTransactions";
import { InvoiceDetailsResponse } from "../types/transactions.types";

export const useGetInvoiceDetails = (invoiceId: number | undefined) => {
  const { i18n } = useTranslation();

  return useQuery({
    queryKey: [...PLANS_QUERY_KEYS.INVOICE_DETAILS, invoiceId, i18n.language],
    queryFn: async (): Promise<InvoiceDetailsResponse> => {
      if (!invoiceId) {
        throw new Error("Invoice ID is required");
      }

      return getInvoiceDetails(invoiceId);
    },
    enabled: !!invoiceId,
  });
};
